// @ts-nocheck
import { useState, useEffect, useContext } from 'react';
import Http from 'services/http2';
import CompanyService from 'services/company2';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TextField, Button } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import { ActionContext } from 'actions/context';
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';
import dayjs from 'dayjs';
/**
 * 请购单单身项次编辑组件
 *
 */
function DialogEditRequisitonLine(props) {
  const { currItem, open, onComplete, onClose, companyCode, fieldSetting } =
    props;
  const [reqInnerTypeList, setReqInnerTypeList] = useState([]);
  const [compUnitList, setCompUnitList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [wbsList, setWbsList] = useState([]);
  const [isInit, setIsInit] = useState(false);
  const [bodyCustData, setBodyCustData] = useState({}); //单身自定义字段数据
  const { state, dispatch } = useContext(ActionContext);
  const { control, handleSubmit, reset } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  });

  useEffect(() => {
    reset(currItem);
    init();

    //初始化bodyCustData
    let bodyCustList = fieldSetting.bodyCustList || [];

    let custData = {};
    //仅显示可编辑字段
    bodyCustList = bodyCustList
      .filter(field => field.editFlag === 1 && field.needVendorInputFlag === 0)
      .forEach(field => {
        custData[field.fieldCode] = currItem?.[field.fieldCode];
      });
    setBodyCustData(custData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, !isInit, currItem, companyCode, self]);

  // 初始化
  async function init() {
    if (isInit || !companyCode) {
      return;
    }

    let list = await CompanyService.getCompEnumList(
      companyCode,
      'B2b_Requisition_Type',
      true
    );
    setReqInnerTypeList(list);

    let curCategoryType = await getCurCategoryType();
    getcategoryList(curCategoryType);
    getCompUnit();
    setIsInit(true);
    getWbsList();
  }

  // 获取请购需求池设置的物料分类
  async function getCurCategoryType() {
    let prodCategoryType: string;
    let postbody = {
      companyCode,
      categoryType: '',
      apiPath: '/req2pur/assignRule/list'
    };
    await Http.post<UserResponse>('/api/cloudCenter', postbody).then(
      response => {
        prodCategoryType = response.data?.prodCategoryType;
      }
    );
    return prodCategoryType;
  }

  // 获取物料分类列表
  async function getcategoryList(curCategoryType) {
    let arr = [];
    let params = {
      orderProperty: 'createTime',
      ascOrDesc: 'desc'
    };
    await CompanyService.getCustomizeCate(
      companyCode,
      [curCategoryType],
      params
    ).then(response => {
      response.forEach(element => {
        arr.push({
          id: element.categoryCode,
          text: '(' + element.categoryCode + ')' + element.categoryName,
          categoryName: element.categoryName
        });
      });
    });
    setCategoryList(arr);
  }

  // 获取物料单位列表
  async function getCompUnit() {
    let postbody = {
      companyCode,
      status: 1,
      apiPath: '/archives/compUnit/getListByCompCode'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        let arr = [];
        data.forEach(item => {
          arr.push({
            id: item.unitCode,
            text: item.unitName,
            name: item.unitName
          });
        });
        setCompUnitList(arr);
      }
    });
  }

  // 获取WBS列表
  async function getWbsList() {
    let postbody = {
      companyCode,
      status: 1, //过滤失效状态
      apiPath: '/archives/wbs/queryByPageResp'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        let arr = response.data.list;
        setWbsList(arr);
      }
    });
  }

  /**
   * 获取枚举字段name
   *
   * @param code
   * @param list
   * @param [nameField] name字段，默认为 'text'
   * @returns
   */
  function getNameByCode(code, list, nameField = 'text', codeField = 'id') {
    for (let item of list) {
      if (code === item[codeField]) {
        return item[nameField];
      }
    }
    return '';
  }

  // 确认
  function ok(formData) {
    formData.reqInnerTypeName = getNameByCode(
      formData.reqInnerTypeCode,
      reqInnerTypeList,
      'subValue'
    );

    // formData.reqUnitName = getNameByCode(
    //   formData.reqUnitCode,
    //   compUnitList,
    //   'text'
    // );

    formData.prodCategoryName = getNameByCode(
      formData.prodCategoryCode,
      categoryList,
      'categoryName'
    );

    formData.wbsName = getNameByCode(
      formData.wbsCode,
      wbsList,
      'wbsName',
      'wbsCode'
    );

    if (!validate(formData)) {
      return;
    }

    if (
      !CustFieldService.validate(
        undefined,
        [bodyCustData],
        fieldSetting,
        true,
        dispatch
      )
    ) {
      return;
    }

    Object.assign(formData, bodyCustData);

    formData.demandDate = dayjs(formData.demandDate).valueOf();
    if (typeof onComplete === 'function') {
      Object.assign(currItem, formData);
      onComplete(formData);
    }
    close();
  }

  // 校验
  function validate(formData) {
    let { reqQty } = formData;
    if (!/^\d+$/.test(reqQty)) {
      return false;
    }
    return true;
  }

  // 关闭
  function close() {
    if (typeof onClose === 'function') {
      onClose();
    }
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={handleSubmit(ok)}>
        <DialogTitle id="form-dialog-title">请购明细</DialogTitle>
        <DialogContent className="mui-dialog-content">
          {/* 新物料 */}
          {currItem?.newFlag === 1 && (
            <span>
              <div className="form-item">
                <p className="form-item-name">物料编码</p>
                <Controller
                  name="productCode"
                  control={control}
                  defaultValue={currItem?.productCode || ''}
                  render={({ field }) => <input type="text" {...field} />}
                />
              </div>
              <div className="form-item">
                <p className="form-item-name">物料名称</p>
                <Controller
                  name="productName"
                  control={control}
                  defaultValue={currItem?.productName || ''}
                  render={({ field }) => <input type="text" {...field} />}
                />
              </div>
              <div className="form-item">
                <p className="form-item-name">物料规格</p>
                <Controller
                  name="productScale"
                  control={control}
                  defaultValue={currItem?.productScale || ''}
                  render={({ field }) => <input type="text" {...field} />}
                />
              </div>
              <div className="form-item">
                <p className="form-item-name">物料分类</p>
                <Controller
                  name="prodCategoryCode"
                  control={control}
                  defaultValue={currItem?.prodCategoryCode || ''}
                  render={({ field }) => (
                    <select {...field}>
                      <option key="-1" value="">
                        请选择
                      </option>
                      {categoryList.map((row, j) => (
                        <option key={j} value={row.id}>
                          {row.text}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>
            </span>
          )}

          <div className="form-item">
            <p className="form-item-name">请购数量</p>
            <Controller
              name="reqQty"
              control={control}
              defaultValue={currItem?.reqQty || ''}
              render={({ field }) => (
                <input type="text" label="请购数量" {...field} />
              )}
            />
          </div>

          {currItem?.newFlag === 1 && (
            <div className="form-item">
              <p className="form-item-name">请购单位</p>
              <Controller
                name="reqUnitName"
                control={control}
                defaultValue={currItem?.reqUnitName || ''}
                render={({ field }) => (
                  <input type="text" label="请购单位" {...field} />
                )}
              />
              {/* <Controller
                name="reqUnitCode"
                control={control}
                defaultValue={currItem?.reqUnitCode || ''}
                render={({ field }) => (
                  <select {...field}>
                    {compUnitList.map((row, i) => (
                      <option key={i} value={row.id}>
                        {row.text}
                      </option>
                    ))}
                  </select>
                )}
              /> */}
            </div>
          )}
          <div className="form-item">
            <p className="form-item-name">需求时间</p>
            <Controller
              name="demandDate"
              control={control}
              defaultValue={
                currItem?.demandDate ? formatDate(currItem.demandDate) : ''
              }
              render={({ field }) => <input type="date" {...field} />}
            />
          </div>
          <div className="form-item">
            <p className="form-item-name">请购类型</p>
            <Controller
              name="reqInnerTypeCode"
              control={control}
              defaultValue={currItem?.reqInnerTypeCode || ''}
              render={({ field }) => (
                <select {...field}>
                  <option key="-1" value="">
                    请选择
                  </option>
                  {reqInnerTypeList.map((row, j) => (
                    <option key={j} value={row.id}>
                      {row.text}
                    </option>
                  ))}
                </select>
              )}
            />
          </div>
          <div className="form-item">
            <p className="form-item-name">品牌</p>
            <Controller
              name="brandName"
              control={control}
              defaultValue={currItem?.brandName || ''}
              render={({ field }) => (
                <input type="text" label="品牌" {...field} />
              )}
            />
          </div>
          <div className="form-item">
            <p className="form-item-name">用途</p>
            <Controller
              name="purpose"
              control={control}
              defaultValue={currItem?.purpose || ''}
              render={({ field }) => (
                <input type="text" label="用途" {...field} />
              )}
            />
          </div>
          <div className="form-item">
            <p className="form-item-name">WBS</p>
            <Controller
              name="wbsCode"
              control={control}
              defaultValue={currItem?.wbsCode || ''}
              render={({ field }) => (
                <select {...field}>
                  <option key="-1" value="">
                    请选择
                  </option>
                  {wbsList.map((row, j) => (
                    <option key={j} value={row.wbsCode}>
                      {row.wbsName}
                    </option>
                  ))}
                </select>
              )}
            />
          </div>
          <div className="form-item">
            {/* 单身自定义字段 */}
            <BodydCustField
              isEdit={true}
              fieldSetting={fieldSetting}
              line={currItem}
              isPurchase={true}
              bodyCustData={bodyCustData}
              setBodyCustData={setBodyCustData}
            ></BodydCustField>
          </div>
        </DialogContent>
        <DialogActions className="dialog-sticky-actions">
          <Button onClick={close} variant="contained">
            取消
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="mui-btn-primary"
          >
            确认
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default DialogEditRequisitonLine;
